<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'New client' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

 

          <div class="form-group">
            <input class="input" type="text" formControlName="name" placeholder="{{ 'NameAr' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="job" placeholder="{{ 'job title' | translate }}" />
          </div>


          <div class="form-group">
            <input class="input" type="text" formControlName="phone"
              placeholder="{{ 'Phone Number' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="number" formControlName="paid"
              placeholder="الدفع" />
          </div>


          <!-- باقي الفيلدات -->
          <div class="form-group">
            <input class="input" type="number" formControlName="remaining"
              placeholder="الباقي" />
          </div>


          <div class="form-group">
            <input class="input" type="text" formControlName="representative"
              placeholder=" المندوب" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="representative_account"
              placeholder="حساب المندوب" />
          </div>



          <div class="form-group">
            <label><input type="radio" formControlName="type" [value]="'0'" />زيارة فرست جروب</label>
            <label><input type="radio" formControlName="type" [value]="'1'" />فيزا فرست جروب</label>
          </div>

          <div class="form-group">
            <textarea class="input" formControlName="notes" placeholder="{{ 'note' | translate }}"></textarea>
          </div>

          <div class="form-group">
            <button type="submit" class="fromsave accont" [disabled]="data.invalid">
              @if(isUpdatePage){
              {{ 'Edit' | translate }}

              }
              @else{
              {{ 'Create Client' | translate }}

              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>